import { useQueryClient } from '@tanstack/react-query';
import debounce from 'lodash/debounce';
import { useCallback, useEffect, useMemo } from 'react';

import { jobArchitectureKeys } from './query-keys';

const REFETCH_WINDOW_MS = 2000;

export const useSkillCatalogRefetch = (): (() => void) => {
    const queryClient = useQueryClient();
    const refetch = useCallback(() => {
        void queryClient.invalidateQueries({ queryKey: [...jobArchitectureKeys.skillCatalog(), 'search'] });
        void queryClient.invalidateQueries({ queryKey: [...jobArchitectureKeys.skillCatalog(), 'statistics'] });
    }, [queryClient]);
    const scheduleRefetch = useMemo(() => debounce(refetch, REFETCH_WINDOW_MS), [refetch]);

    useEffect(() => () => scheduleRefetch.flush(), [scheduleRefetch]);

    return scheduleRefetch;
};
